class BoardItem {
  memberId: number;
  text: string = '';
  deadline: number = Date.now() + 24 * 60 * 60 * 1000;
  type: number;
  created: number;
  updated: number;
  completed: boolean;
}

export default BoardItem;



// WEBPACK FOOTER //
// ./src/entities/BoardItem.ts